<template>
  <div class="files-list-section">
    <h2>
      {{ constants.RECENT_PROJECT_FILES_TEXT }}
    </h2>
    <div class="files-list-hd">
      <ul>
        <li>
          <strong>
            {{ constants.NAME_TEXT }}
          </strong>
        </li>
        <li>
          <strong>
            {{ constants.CHAT_ROOM_TEXT }}
          </strong>
        </li>
        <li>
          <strong>
            {{ constants.SHARED_BY_TEXT }}
          </strong>
        </li>
        <li>
          <strong>
            {{ constants.DATE_TEXT }}
          </strong>
        </li>
        <li>
          <strong>
            {{ constants.SIZE_TEXT }}
          </strong>
        </li>
        <li>
          <strong>
            {{ constants.ACTION_TEXT }}
          </strong>
        </li>
      </ul>
    </div>
    <div class="files-list-btm">
      <div class="files-list-row">
        <ul>
          <li>
            <div class="files-d-b">
              <i>
                <img
                  src="@/assets/lems-v1/images/file-type/folder.svg"
                  alt=""
                />
              </i>
              <div class="files-d-b-span">
                <strong>Wellbux Client Folder</strong>
                <p>This file attached to Wellbux</p>
              </div>
            </div>
          </li>
          <li data-title="CHAT ROOM">
            <a class="link" id="chatLink" href="employee-chat.html">
              {{ constants.CHAT_LINK_LINK }}
            </a>
          </li>
          <li data-title="SHARED BY">Ashok</li>
          <li data-title="DATE">Apr. 5, 2021, 8:15 am</li>
          <li data-title="SIZE">
            293
            {{ constants.MB_TEXT }}
          </li>
          <li data-title="ACTION">
            <div class="action-dropdown">
              <a href="javascript:void(0);" class="action-dots">
                <span></span>
              </a>
              <div class="action-dropdownbox">
                <div class="action-dropdownbox-in">
                  <!-- <a class="rename-icon" href="#">Rename</a>
                                                                <a class="delete-icon" href="#">Delete</a> -->
                  <a
                    class="download-icon"
                    id="downloadLink"
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#fileDownloadPop"
                  >
                    {{ constants.DOWNLOAD_LINK }}
                  </a>
                  <a
                    class="delete-icon"
                    id="deleteFileLink"
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteFile"
                  >
                    {{ constants.DELETE_LINK }}
                  </a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="files-list-row">
        <ul>
          <li>
            <div class="files-d-b">
              <i>
                <img src="@/assets/lems-v1/images/file-type/audio.svg" alt="" />
              </i>
              <div class="files-d-b-span">
                <strong>Wellbux discuss with Binod.mp3</strong>
                <p>This file attached to Wellbux</p>
              </div>
            </div>
          </li>
          <li data-title="CHAT ROOM">
            <a class="link" id="chatLink" href="employee-chat.html">
              {{ constants.CHAT_LINK_LINK }}
            </a>
          </li>
          <li data-title="SHARED BY">Binod</li>
          <li data-title="DATE">Apr. 5, 2021, 8:15 am</li>
          <li data-title="SIZE">
            400
            {{ constants.MB_TEXT }}
          </li>
          <li data-title="ACTION">
            <div class="action-dropdown">
              <a href="javascript:void(0);" class="action-dots">
                <span></span>
              </a>
              <div class="action-dropdownbox">
                <div class="action-dropdownbox-in">
                  <!-- <a class="rename-icon" href="#">Rename</a>
                                                                <a class="delete-icon" href="#">Delete</a> -->
                  <a
                    class="download-icon"
                    id="downloadLink"
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#fileDownloadPop"
                  >
                    {{ constants.DOWNLOAD_LINK }}
                  </a>
                  <a
                    class="delete-icon"
                    id="deleteFileLink"
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteFile"
                  >
                    {{ constants.DELETE_LINK }}
                  </a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="files-list-row">
        <ul>
          <li>
            <div class="files-d-b">
              <i>
                <img src="@/assets/lems-v1/images/file-type/image.svg" alt="" />
              </i>
              <div class="files-d-b-span">
                <strong>Wellbux Logo.png</strong>
                <p>This file attached to Wellbux</p>
              </div>
            </div>
          </li>
          <li data-title="CHAT ROOM">
            <a class="link" id="chatLink" href="employee-chat.html">
              {{ constants.CHAT_LINK_LINK }}
            </a>
          </li>
          <li data-title="SHARED BY">Ashok</li>
          <li data-title="DATE">Apr. 5, 2021, 8:15 am</li>
          <li data-title="SIZE">
            1
            {{ constants.MB_TEXT }}
          </li>
          <li data-title="ACTION">
            <div class="action-dropdown">
              <a href="javascript:void(0);" class="action-dots">
                <span></span>
              </a>
              <div class="action-dropdownbox">
                <div class="action-dropdownbox-in">
                  <!-- <a class="rename-icon" href="#">Rename</a>
                                                                <a class="delete-icon" href="#">Delete</a> -->
                  <a
                    class="download-icon"
                    id="downloadLink"
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#fileDownloadPop"
                  >
                    {{ constants.DOWNLOAD_LINK }}
                  </a>
                  <a
                    class="delete-icon"
                    id="deleteFileLink"
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteFile"
                  >
                    {{ constants.DELETE_LINK }}
                  </a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="files-list-row">
        <ul>
          <li>
            <div class="files-d-b">
              <i>
                <img src="@/assets/lems-v1/images/file-type/pdf.svg" alt="" />
              </i>
              <div class="files-d-b-span">
                <strong>Wellbux-pics.pdf</strong>
                <p>This file attached to Wellbux</p>
              </div>
            </div>
          </li>
          <li data-title="CHAT ROOM">
            <a class="link" id="chatLink" href="employee-chat.html">
              {{ constants.CHAT_LINK_LINK }}
            </a>
          </li>
          <li data-title="SHARED BY">Monika</li>
          <li data-title="DATE">Apr. 5, 2021, 8:15 am</li>
          <li data-title="SIZE">
            293
            {{ constants.MB_TEXT }}
          </li>
          <li data-title="ACTION">
            <div class="action-dropdown">
              <a href="javascript:void(0);" class="action-dots">
                <span></span>
              </a>
              <div class="action-dropdownbox">
                <div class="action-dropdownbox-in">
                  <!-- <a class="rename-icon" href="#">Rename</a>
                        <a class="delete-icon" href="#">Delete</a> -->
                  <a
                    class="download-icon"
                    id="downloadLink"
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#fileDownloadPop"
                  >
                    {{ constants.DOWNLOAD_LINK }}
                  </a>
                  <a
                    class="delete-icon"
                    id="deleteFileLink"
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteFile"
                  >
                    {{ constants.DELETE_LINK }}
                  </a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";

export default defineComponent({
  name: "ProjectRecentFiles",
  data() {
    return {
      constants,
    };
  },
});
</script>
